export const PAYMENT_STATUS_NAMES = {
  DRAFT: 'draft',
  REQUESTED: 'requested',
  VERIFIED: 'verified',
  REJECTED: 'rejected',
};
